module.exports = __webpack_public_path__ + "static/media/open-sans-v17-latin-ext_latin-600.e16f375b.svg";